import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, DatePicker } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { data3_2_1 } from './data';
import imgSave from "../../table/saveImg";
import Auth from "../../table/Auth";
import { compute } from "./compute";
import FileSaver from "file-saver";
import TableText from "../../table/TableText";

const { MonthPicker } = DatePicker;
const totalIndex = [];

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            dateData: [],
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            monthDataAll: {}
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        data = await compute(data);
        console.log(data);
        this.setState({ data });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getHeadquartersMonth?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length >= 0) {
                data = x.data;
            }
            this.setState({ loading: false, }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }


    downloadExcel = () => {
        const tableName = `${moment(this.state.date).format('YYYY-MM')} Revenue monthly summary 单体酒店月度收益报表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }


    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth - 3700 > 700 ? document.body.offsetWidth - 3700 : 700;

        const columns = [{
            title: 'SITE NO.',
            dataIndex: 'wdm_number',
            key: 'NO',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: 100,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {text}
                    </div >
                )
            }
        }, {
            title: 'Hotel Name',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: width * (7 / 12),
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {record.name.replace(/[^a-zA-Z0-9\s]/g, '')}
                    </div >
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name_cn',
            key: 'name_cn',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: width * (5 / 12),
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {record.name.replace(/[^\u4E00-\u9FA5]/g, "")}
                    </div >
                )
            }
        }, {
            title: `Year End`,
            children: [{
                title: 'Budget',
                align: "center",
                children: [
                    {
                        title: 'Nts',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_budget_nts',
                        key: 'end_budget_nts',
                        sorter: (a, b) => a.end_budget_nts - b.end_budget_nts,
                        render: (text, record, index) => {
                            const title = ['Year End', `Budget`, 'Nts'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "end_budget_nts",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'ADR',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_budget_adr',
                        key: 'end_budget_adr',
                        sorter: (a, b) => a.end_budget_adr - b.end_budget_adr,
                        render: (text, record, index) => {
                            const title = ['Year End', `Budget`, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "end_budget_adr",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Revenue',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_budget_rev',
                        key: 'end_budget_rev',
                        sorter: (a, b) => a.end_budget_rev - b.end_budget_rev,
                        render: (text, record, index) => {
                            const title = ['Year End', `Budget`, 'Revenue'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "end_budget_rev",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Occ%',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_budget_occ',
                        key: 'end_budget_occ',
                        sorter: (a, b) => a.end_budget_occ - b.end_budget_occ,
                        render: (text, record, index) => {
                            const title = ['Year End', `Budget`, 'Occ%'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "end_budget_occ",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    }
                ]

            }, {
                title: 'Acutal+Forecast',
                align: "center",
                width: 150,
                children: [
                    {
                        title: 'Nts',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_actual_nts',
                        key: 'end_actual_nts',
                        sorter: (a, b) => a.end_actual_nts - b.end_actual_nts,
                        render: (text, record, index) => {
                            const title = ['Year End', `Acutal+Budget`, 'Nts'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "end_actual_nts",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'ADR',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_actual_adr',
                        key: 'end_actual_adr',
                        sorter: (a, b) => a.end_actual_adr - b.end_actual_adr,
                        render: (text, record, index) => {
                            const title = ['Year End', `Acutal+Budget`, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "end_actual_adr",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Revenue',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_actual_rev',
                        key: 'end_actual_rev',
                        sorter: (a, b) => a.end_actual_rev - b.end_actual_rev,
                        render: (text, record, index) => {
                            const title = ['Year End', `Acutal+Budget`, 'Revenue'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "end_actual_rev",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Occ%',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_actual_occ',
                        key: 'end_actual_occ',
                        sorter: (a, b) => a.end_actual_occ - b.end_actual_occ,
                        render: (text, record, index) => {
                            const title = ['Year End', `Acutal+Budget`, 'Occ%'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "end_actual_occ",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    }
                ]

            }, {
                title: 'Varies',
                align: "center",
                width: 150,
                children: [
                    {
                        title: 'Nts',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_varies_nts',
                        key: 'end_varies_nts',
                        sorter: (a, b) => a.end_varies_nts - b.end_varies_nts,
                        render: (text, record, index) => {
                            const title = ['Year End', `Varies`, 'Nts'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "end_varies_nts",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'ADR',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_varies_adr',
                        key: 'end_varies_adr',
                        sorter: (a, b) => a.end_varies_adr - b.end_varies_adr,
                        render: (text, record, index) => {
                            const title = ['Year End', `Varies`, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "end_varies_adr",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Revenue',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_varies_rev',
                        key: 'end_varies_rev',
                        sorter: (a, b) => a.end_varies_rev - b.end_varies_rev,
                        render: (text, record, index) => {
                            const title = ['Year End', `Varies`, 'Revenue'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "end_varies_rev",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Occ%',
                        align: "center",
                        width: 150,
                        dataIndex: 'end_varies_occ',
                        key: 'end_varies_occ',
                        sorter: (a, b) => a.end_varies_occ - b.end_varies_occ,
                        render: (text, record, index) => {
                            const title = ['Year End', `Varies`, 'Occ%'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "end_varies_occ",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    }
                ]

            }]
        }, {
            title: `YTD`,
            children: [{
                title: 'Budget',
                align: "center",
                children: [
                    {
                        title: 'Nts',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_budget_nts',
                        key: 'ytd_budget_nts',
                        sorter: (a, b) => a.ytd_budget_nts - b.ytd_budget_nts,
                        render: (text, record, index) => {
                            const title = ['YTD', `Budget`, 'Nts'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "ytd_budget_nts",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'ADR',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_budget_adr',
                        key: 'ytd_budget_adr',
                        sorter: (a, b) => a.ytd_budget_adr - b.ytd_budget_adr,
                        render: (text, record, index) => {
                            const title = ['YTD', `Budget`, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "ytd_budget_adr",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Revenue',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_budget_rev',
                        key: 'ytd_budget_rev',
                        sorter: (a, b) => a.ytd_budget_rev - b.ytd_budget_rev,
                        render: (text, record, index) => {
                            const title = ['YTD', `Budget`, 'Revenue'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "ytd_budget_rev",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Occ%',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_budget_occ',
                        key: 'ytd_budget_occ',
                        sorter: (a, b) => a.ytd_budget_occ - b.ytd_budget_occ,
                        render: (text, record, index) => {
                            const title = ['YTD', `Budget`, 'Occ%'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "ytd_budget_occ",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    }
                ]

            }, {
                title: 'Acutal',
                align: "center",
                width: 150,
                children: [
                    {
                        title: 'Nts',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_actual_nts',
                        key: 'ytd_actual_nts',
                        sorter: (a, b) => a.ytd_actual_nts - b.ytd_actual_nts,
                        render: (text, record, index) => {
                            const title = ['YTD', `Acutal`, 'Nts'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "ytd_actual_nts",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'ADR',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_actual_adr',
                        key: 'ytd_actual_adr',
                        sorter: (a, b) => a.ytd_actual_adr - b.ytd_actual_adr,
                        render: (text, record, index) => {
                            const title = ['YTD', `Acutal`, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "ytd_actual_adr",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Revenue',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_actual_rev',
                        key: 'ytd_actual_rev',
                        sorter: (a, b) => a.ytd_actual_rev - b.ytd_actual_rev,
                        render: (text, record, index) => {
                            const title = ['YTD', `Acutal`, 'Revenue'];
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: "ytd_actual_rev",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Occ%',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_actual_occ',
                        key: 'ytd_actual_occ',
                        sorter: (a, b) => a.ytd_actual_occ - b.ytd_actual_occ,
                        render: (text, record, index) => {
                            const title = ['YTD', `Acutal`, 'Occ%'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "ytd_actual_occ",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    }
                ]

            }, {
                title: 'Varies',
                align: "center",
                width: 150,
                children: [
                    {
                        title: 'Nts',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_varies_nts',
                        key: 'ytd_varies_nts',
                        sorter: (a, b) => a.ytd_varies_nts - b.ytd_varies_nts,
                        render: (text, record, index) => {
                            const title = ['YTD', `Varies`, 'Nts'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "ytd_varies_nts",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'ADR',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_varies_adr',
                        key: 'ytd_varies_adr',
                        sorter: (a, b) => a.ytd_varies_adr - b.ytd_varies_adr,
                        render: (text, record, index) => {
                            const title = ['YTD', `Varies`, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "ytd_varies_adr",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Revenue',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_varies_rev',
                        key: 'ytd_varies_rev',
                        sorter: (a, b) => a.ytd_varies_rev - b.ytd_varies_rev,
                        render: (text, record, index) => {
                            const title = ['YTD', `Varies`, 'Revenue'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "ytd_varies_rev",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    },
                    {
                        title: 'Occ%',
                        align: "center",
                        width: 150,
                        dataIndex: 'ytd_varies_occ',
                        key: 'ytd_varies_occ',
                        sorter: (a, b) => a.ytd_varies_occ - b.ytd_varies_occ,
                        render: (text, record, index) => {
                            const title = ['YTD', `Varies`, 'Occ%'];
                            const props = {
                                text,
                                index,
                                type: 'percent',
                                name: "ytd_varies_occ",
                                onChange: this.onChange,
                                totalIndex,
                            };

                            return (
                                <TableText data={{ ...props }} />
                            )
                        }
                    }
                ]

            }]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_1_1" style={{ width: this.state.print ? 4450 : 'auto' }}>
                        <Row>Revenue monthly summary 单体酒店月度收益报表</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 4400 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 4400, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.downloadExcel();
                                    });
                                }}
                                loading={this.state.print}
                            >导出Excel</Button>
                        </Row>
                    </Auth>


                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/4_2Month/index.js